var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDirections(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5129_67738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.5631 11.1362L18.561 11.1382L11.0693 18.6299C10.7742 18.925 10.3881 19.0693 10.0004 19.0693C9.61269 19.0693 9.22662 18.925 8.93146 18.6299L1.43146 11.1299C0.840035 10.5385 0.840035 9.58343 1.43146 8.99201L8.93146 1.49201C9.50573 0.917735 10.5108 0.925105 11.0777 1.49201L18.584 8.9983C18.5843 8.99864 18.5846 8.99898 18.585 8.99932C19.17 9.60826 19.1594 10.5624 18.5631 11.1362ZM9.90266 17.667L10.0087 17.7731L10.1148 17.667L17.6148 10.167L17.7209 10.0609L17.6148 9.95488L10.1148 2.45488L10.0087 2.34881L9.90266 2.45488L2.40266 9.95488L2.29659 10.0609L2.40266 10.167L9.90266 17.667ZM8.33372 9.91928H8.18372V10.0693V12.4193H6.81706V9.23594C6.81706 8.86045 7.1249 8.55261 7.50039 8.55261H11.6671H11.8171V8.40261V6.68141L14.3716 9.23594L11.8171 11.7905V10.0693V9.91928H11.6671H8.33372Z",
    fill: "black",
    stroke: "#F4F5F7",
    strokeWidth: 0.3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5129_67738"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.0693359)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirections);
export default __webpack_public_path__ + "static/media/Directions.7d2114210958f45f2365767a18257fd2.svg";
export { ForwardRef as ReactComponent };